import { BRAND_THEME } from "./brandTheme";
import { MODULE_TAB_BTN, MODULE_TAB_ICON_SIZE } from "./pageChrome";

/**
 * Patient-style module shell: titled panel + icon tab grid + content pad.
 * Reuse across Dashboard, Billing-like modules, etc. Theme defaults to brand
 * (Patient palette); pass `theme` to override.
 */
export default function ModuleTabPanel({
  tabs = [],
  activeTab,
  onTabChange,
  theme = BRAND_THEME,
  children,
  className = "",
  contentClassName = "bg-slate-50/50 p-3 sm:p-4",
}) {
  const colCount = Math.max(tabs.length, 1);
  const gridClass =
    colCount === 1
      ? "grid-cols-1"
      : colCount === 2
        ? "grid-cols-2"
        : colCount === 3
          ? "grid-cols-3"
          : colCount === 4
            ? "grid-cols-2 sm:grid-cols-4"
            : "grid-cols-2 sm:grid-cols-3 lg:grid-cols-5";

  return (
    <div
      className={`bg-white rounded-xl border shadow-sm overflow-hidden ${theme.section.wrap} ${className}`}
    >
      <nav
        className={`grid ${gridClass} w-full shrink-0 border-b ${theme.section.head}`}
      >
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const active = activeTab === tab.id;
          return (
            <button
              key={tab.id}
              type="button"
              onClick={() => onTabChange?.(tab.id)}
              className={`${MODULE_TAB_BTN} border-indigo-100 ${
                active ? theme.tab.active : theme.tab.inactive
              }`}
            >
              {Icon ? <Icon size={MODULE_TAB_ICON_SIZE} className="shrink-0" /> : null}
              <span className="truncate">{tab.label}</span>
              {active ? (
                <span
                  className={`absolute left-0 right-0 bottom-0 h-0.5 ${theme.tab.underline}`}
                />
              ) : null}
            </button>
          );
        })}
      </nav>

      <div className={`${contentClassName}`}>{children}</div>
    </div>
  );
}
